import { Loader2 } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth';
import { BrandMark } from '../components/Layout';
import { ErrorBox } from '../components/ui';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err) {
      setError(err);
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <form className="card auth-card" onSubmit={submit}>
        <div className="brand">
          <BrandMark />
          <div>
            OCR 1SK
            <small>ocr.1sk.us</small>
          </div>
        </div>
        <h1>Iniciar sesión</h1>
        <ErrorBox error={error} />
        <div className="field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            className="input"
            type="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="password">Contraseña</label>
          <input
            id="password"
            className="input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button className="btn btn-primary" disabled={busy}>
          {busy && <Loader2 size={15} className="spin" />}
          Entrar
        </button>
        <p className="faint" style={{ fontSize: 12.5, textAlign: 'center', marginTop: 14 }}>
          ¿Sin acceso? Pide una cuenta al administrador de tu grupo.
        </p>
      </form>
    </div>
  );
}
